import type { RecorderTypeType } from '@/types/domain/childNotebook/valueObjects/recorderType';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 記録者種別
 */
export class RecorderType extends PrimitiveValueObject<RecorderTypeType> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: RecorderTypeType): RecorderType {
    return new RecorderType(value);
  }
}
